<template>
    <div>
        <card>
            <Form ref="searchForm" :model="searchForm" inline class="searchForm" id="searchFormSection" @keyup.enter.native="getData()">
                <FormItem prop="date">
                    <DatePicker type="date" placeholder="选择日期"
                                format="yyyy-MM-dd" @on-change="searchForm.date=$event"
                                :value="searchForm.date" ></DatePicker>
                </FormItem>
                <Form-item prop="zoneId" label="校区" :label-width="60">
                    <Select v-model="searchForm.zoneId" filterable style="width: 250px" placeholder="全部" clearable>
                        <Option v-for="item in zoneList" :value="item.id" :key="item.id">{{ item.name}}</Option>
                    </Select>
                </Form-item>
                <FormItem>
                    <Select v-model="searchForm.teacherId" style="width:200px;" placeholder="选择教师">
                        <Option v-for="(item,index) in teacherList" :key="index" :value="item.id">
                            {{item.name}}
                        </Option>
                    </Select>
                </FormItem>
                <FormItem>
                    <Button type="primary" @click="getData"  size="small">搜索</Button>
                </FormItem>
            </Form>
            <Table :columns="columns" :data="data">
                <template slot-scope="{ row, index }" slot="sender">
                    <Tag color="primary" v-if="row.type == 1">{{row.teacherName}}</Tag>
                    <Tag color="success" v-else>{{row.studentName}}家长</Tag>
                    <span style="font-size:18px;color:blue;margin-left:20px;">→</span>
                </template>
                <template slot-scope="{ row, index }" slot="receiver">
                    <Tag color="primary" v-if="row.type == 2">{{row.teacherName}}</Tag>
                    <Tag color="success" v-else>{{row.studentName}}家长</Tag>
                </template>
            </Table>
        </card>
    </div>
</template>
<script>
    import moment from 'moment';
    export default {
        name: 'report_class_hour',
        data () {
            return {
                searchForm:{
                    date:moment(new Date()).format("YYYY-MM-DD"),
                    zoneId:this.$store.state.app.zoneList[0].id,
                    teacherId:null
                },
                columns: [
                    {
                        title: '发送方',
                        slot: 'sender',
                        width:200
                    },
                    {
                        title: '接收方',
                        slot: 'receiver',
                        width:100
                    },
                    {
                        title: '课程',
                        key: 'course',
                        width:100
                    },
                    {
                        title: '内容',
                        key: 'msg'
                    },
                    {
                        title: '时间',
                        key: 'createtime',
                        width:100
                    }
                ],
                data: [],
            }
        },
        computed: {
            zoneList() {
                return this.$store.state.app.zoneList
            },
            teacherList() {
                return this.$store.state.app.teacherList
            },
        },
        methods: {
            getData(){
                this.$api.report.msg({
                    zoneId:this.searchForm.zoneId,
                    date:this.searchForm.date,
                    teacherId:this.searchForm.teacherId
                }).then(resp => {
                    this.data = resp.list;
                });
            }
        },
        mounted: function () {
            this.getData();
        }
    }
</script>
